var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content md"},[_c('a-card',{attrs:{"bordered":false,"title":"动态通知"}},[_c('msg-list',{attrs:{"list":_vm.list}}),_c('a-pagination',_vm._b({staticStyle:{"margin-top":"10px","text-align":"right"},on:{"change":_vm.handlePageChange}},'a-pagination',_vm.pagination,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }